<template>
  <div>
    <template v-if="user.company">
      <router-view name="menu" @toggle-drawer="toggleDrawer"></router-view>
      <partial-drawer-navigation :class="{'sidenav-open': showDrawer}"></partial-drawer-navigation>
    </template>
    <div class="page-container">
      <transition name="fade" mode="out-in">
        <router-view></router-view>
      </transition>
      <vue-snotify></vue-snotify>
    </div>
    <CoockiesModal/>
    <partial-footer></partial-footer>
  </div>
</template>

<script>
  import {mapState, mapActions} from 'vuex'
  import * as env from './env'
  import Echo from 'laravel-echo'
  import PartialFooter from './pages/partials/PartialFooter'
  import PartialDrawerNavigation from './pages/partials/PartialDrawerNavigation'
  import CoockiesModal from './components/app/login/CoockiesModal'

  export default {
    components: {
      PartialFooter,
      PartialDrawerNavigation,
      CoockiesModal
    },
    data () {
      return {
        showDrawer: false
      }
    },
    computed: {
      ...mapState({
        user: state => state.user
      })
    },
    watch: {
      '$route' (to, from) {
        this.showDrawer = false
      },
      user (to, from) {
        if (to.company && to.company.hash) {
          this.subscribeChannel()
        }
      }
    },
    created () {
      if (!window.Echo) {
        window.Pusher = require('pusher-js')
        let options = env.lavarelEchoConfig.pusher
        if (this.$store.state.user.access_token) {
          options.auth = {
            headers: {
              'Authorization': 'Bearer ' + this.$store.state.user.access_token,
              'ClientId': env.clientId
            }
          }
        }
        window.Echo = new Echo(options)
      }
      this.subscribeChannel()
      if (window.Channel) {
        this.listenEvents()
        this.getNotificationsPanel()
      }
    },
    methods: {
      toggleDrawer () {
        this.showDrawer = !this.showDrawer
      },
      getNotificationsPanel () {
        this.$http.get('notifications_panel')
          .then((response) => {
            this.changeNotificationsPanel(response.data)
          }, (error) => {
            console.log(error)
          })
      },
      listenEvents () {
        window.Channel.listen('.App\\Events\\AdminNotificationsPanel', (e) => {
          this.changeNotificationsPanel(e)
        })
      },
      ...mapActions(['changeNotificationsPanel'])
    },
    beforeDestroy () {
      this.unsubscribeChannel()
    }
  }
</script>

<style lang="scss">
  @import "./sass/main";
  @import '~vue-snotify/styles/material.css';
</style>



// WEBPACK FOOTER //
// App.vue?f6e7409a